import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import {useEffect} from 'react';
import {setDarkModeForUserPreference} from 'components/DarkModeButton/DarkModeButton';
import {
  AppointmentConfirmationScreenContainer,
  AppointmentManagementScreenContainer,
  BookingCheckoutScreenContainer,
  BookingSurveyScreenContainer,
} from 'InsomniaConfigScreens';

const BookingRootRedirect = () => {
  const location = useLocation();
  const to = `/book-appointment/start${location.search}`;
  return <Navigate to={to} replace />;
};

/**
 * Clinic intake that books a real appointment. Same onboarding questions as the
 * SleepioRx funnel at `/start`, but eligible patients pick a session time, check
 * out, and get an appointment scheduled through the eligibility API.
 *
 * Kept on its own route prefix so the two funnels can run side by side without
 * a feature flag — see surveys/insomnia_funnel/survey/insomnia_booking.tsx.
 */
export const BookAppointmentRoutes = () => {
  useEffect(() => {
    setDarkModeForUserPreference();
  }, []);

  return (
    <Routes>
      <Route path="/" element={<BookingRootRedirect />} />
      <Route index path="start" element={<BookingSurveyScreenContainer />} />
      <Route path="checkout" element={<BookingCheckoutScreenContainer />} />
      <Route path="appointment-confirmation" element={<AppointmentConfirmationScreenContainer />} />
      <Route path="appt" element={<AppointmentManagementScreenContainer />} />
    </Routes>
  );
};
